import { Route } from "@angular/router";
import { AboutComponent } from "./app/about/about.component";
import { AuthorizeGuardRole } from "./app/api-authorization/guards/authorize-by-role.guard";
import { AuthorizeGuard } from "./app/api-authorization/guards/authorize.guard";
import { DashboardComponent } from "./app/common/components/dashboard/dashboard.component";
import { SwitchOrganizationComponent } from "./app/common/components/switch-organization/switch-organization.component";
import { SystemRoles } from "./app/common/models/system-roles-enum";
import { FetchDataComponent } from "./app/fetch-data/fetch-data.component";
import { HomeComponent } from "./app/home/home.component";
import { BreadCrumb } from "./app/common/ui/models/bread-crumb.model";

export const ROUTES: Route[] = [
  {
    path: 'administration',
    canActivate: [AuthorizeGuardRole],
    data: {
      roles: [SystemRoles.Administrator],
      breadcrumb: { label: 'Administration', clickable: false } as BreadCrumb
    },
    loadChildren: () => import('./app/admin/admin-routes.model').then(m => m.ADMIN_ROUTES),
  },
  {
    path: 'organization',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./app/organization/organization-routes.model').then(m => m.ORGANIZATION_ROUTES),
  },
  {
    path: 'user',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./app/user/user-routes.model').then(m => m.USER_ROUTES),
  },
  {
    path: 'disclosure',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./app/disclosure/disclosure-routes.model').then(m => m.DISCLOSURE_ROUTES),
  },
  {
    path: 'organization-reports',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./app/reports/reports-routes.model').then(m => m.REPORTS_ROUTES),
  },
  {
    path: 'authentication',
    data: {
      action: "authentication",
    },
    loadChildren: () => import('./app/api-authorization/api-authorization-routes.model').then(m => m.API_AUTH_ROUTES),
  },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthorizeGuard], data: { action: "dashboard" } },
  { path: 'switch-organization', component: SwitchOrganizationComponent, canActivate: [AuthorizeGuard], data: { action: "switchOrganization" } },
  { path: 'fetch-data', component: FetchDataComponent, canActivate: [AuthorizeGuardRole], data: { roles: [SystemRoles.Administrator], breadcrumb: 'Fetch Data Test' } },
  { path: 'about', component: AboutComponent },
  { path: '', component: HomeComponent },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
]
